import './calendarType.css';
import {useState} from "react";

const CalendarType = ({type = 'month'}) => {

    const [calendarType, setCalendarType] = useState(type);

    const handleCalendarClick = (val) => {
        setCalendarType(val);
    }

    return(
        <ul className="period-tab sf-bold flex font-14 grey-color">
            <li onClick={e => handleCalendarClick('week')}
                className={calendarType === 'week' ? 'active' : ''}>Week</li>
            <li onClick={e => handleCalendarClick('month')}
                className={calendarType === 'month' ? 'active' : ''}>Month</li>
            <li onClick={e => handleCalendarClick('year')}
                className={calendarType === 'year' ? 'active' : ''}>Year 2023</li>
        </ul>
    )
}

export default CalendarType;
